import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    // Carga optimista desde localStorage para evitar parpadear al login
    // mientras /auth/me valida la sesión contra el backend.
    const [user, setUser] = useState(() => {
        try {
            const cached = localStorage.getItem("foresta_user");
            const token = localStorage.getItem("foresta_token");
            return token && cached ? JSON.parse(cached) : null;
        } catch { return null; }
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("foresta_token");
        if (!token) { setLoading(false); return; }
        api.get("/auth/me")
            .then((r) => { setUser(r.data); localStorage.setItem("foresta_user", JSON.stringify(r.data)); })
            .catch((err) => {
                // Solo limpiar la sesión si el backend la rechazó (401).
                // Errores de red (offline, timeout) NO deben deslogear.
                if (err?.response?.status === 401) {
                    localStorage.removeItem("foresta_token");
                    localStorage.removeItem("foresta_user");
                    setUser(null);
                }
            })
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const r = await api.post("/auth/login", { email, password });
        localStorage.setItem("foresta_token", r.data.access_token);
        localStorage.setItem("foresta_user", JSON.stringify(r.data.user));
        setUser(r.data.user);
        return r.data.user;
    };

    const logout = () => {
        localStorage.removeItem("foresta_token");
        localStorage.removeItem("foresta_user");
        setUser(null);
        window.location.href = "/login";
    };

    const refresh = async () => {
        const r = await api.get("/auth/me");
        setUser(r.data);
        localStorage.setItem("foresta_user", JSON.stringify(r.data));
    };

    return (
        <AuthCtx.Provider value={{ user, loading, login, logout, refresh, setUser }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);

export function getRoles(user) {
    if (!user) return new Set();
    return new Set([user.rol, ...(user.roles_extra || [])]);
}
export function hasAnyRole(user, ...roles) {
    const r = getRoles(user);
    if (r.has("admin")) return true;
    return roles.some((x) => r.has(x));
}
export function isMaster(user) {
    return user?.usuario_edificio?.es_master === true;
}

export function isCoworking(user) {
    return user?.usuario_edificio?.unidad?.piso === "Coworking";
}
